import { Injectable }         from '@angular/core';
import {
	getYear,
	getYearMonth,
	getYearMonthDay
}                             from '@app/modules/usage/helpers/usage-month.helper';
import {
	IUsagePeriod,
	UsagePeriodTypeEnum
}                             from '@app/modules/usage/models/common-usage.model';
import { ProductEnum }        from '@core/interfaces/common.interfaces';
import { TranslationService } from '@core/services/translation.service';
import { LoggerService }      from '@shared/services/logger.service';
import { ToasterService }     from '@shared/services/toaster.service';

@Injectable( { providedIn: 'root' } )
export class ProductHelperService {

	constructor(
		private readonly logger: LoggerService,
		private readonly toaster: ToasterService,
		private readonly translationService: TranslationService
	) {
		this.logger.trace( 'ContractHelperService constructor' );
	}

	private getPeriod( usagePeriod: IUsagePeriod ): string {
		switch ( usagePeriod.type ) {
			case UsagePeriodTypeEnum.YEAR:
				return getYear( usagePeriod.date );

			case UsagePeriodTypeEnum.YEAR_MONTH:
				return getYearMonth( usagePeriod.date );

			case UsagePeriodTypeEnum.YEAR_MONTH_DAY:
				return getYearMonthDay( usagePeriod.date );
		}
	}

	executeProductAction(
		product: ProductEnum,
		archiveAction: () => void,
		elsterAction: () => void,
		fiskalAction: () => void
	): void {
		switch ( product ) {
			case ProductEnum.ARCHIVE:
				archiveAction();
				break;
			case ProductEnum.ELSTER:
				elsterAction();
				break;
			case ProductEnum.FISCAL:
				fiskalAction();
				break;
		}
	}

	executeProductActionAndReturnValue<archive, elster, fiskal>(
		product: ProductEnum,
		archiveAction: () => archive,
		elsterAction: () => elster,
		fiskalAction: () => fiskal
	): archive | elster | fiskal {
		switch ( product ) {
			case ProductEnum.ARCHIVE:
				return archiveAction() as archive;
			case ProductEnum.ELSTER:
				return elsterAction() as elster;
			case ProductEnum.FISCAL:
				return fiskalAction() as fiskal;
		}
	}

	getProductData<archive, elster, fiskal>(
		product: ProductEnum,
		archiveValue: archive,
		elsterValue: elster,
		fiskalValue: fiskal,
	): archive | elster | fiskal {
		switch ( product ) {
			case ProductEnum.ARCHIVE:
				return archiveValue as archive;
			case ProductEnum.ELSTER:
				return elsterValue as elster;
			case ProductEnum.FISCAL:
				return fiskalValue as fiskal;
		}
	}

	getProductUsagePeriod(
		product: ProductEnum,
		archiveUsagePeriod: IUsagePeriod,
		elsterUsagePeriod: IUsagePeriod,
		fiskalUsagePeriod: IUsagePeriod
	): string {
		return this.getProductData<string, string, string>(
			product,
			this.getPeriod( archiveUsagePeriod ),
			this.getPeriod( elsterUsagePeriod ),
			this.getPeriod( fiskalUsagePeriod )
		);
	}
}
